import { render, staticRenderFns } from "./w-dropdown.vue?vue&type=template&id=489bc64c&scoped=true"
import script from "./w-dropdown.vue?vue&type=script&lang=ts"
export * from "./w-dropdown.vue?vue&type=script&lang=ts"
import style0 from "./w-dropdown.vue?vue&type=style&index=0&id=489bc64c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489bc64c",
  null
  
)

export default component.exports